import styled from 'styled-components';

export const LoginStyled = styled.div`
  width: 100%;
  padding: 120px 45px;
  padding-top: clamp(40px, 15vh, 120px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;

  .login_container {
    width: 100%;
  }

  .login_logo_text1 {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.6px;
  }

  .login_logo_text2 {
    font-family: Pretendard;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 100% */
    letter-spacing: -0.96px;
  }

  .login_divider {
    width: 100%;
    height: 1px;
    background: var(--GrayScale-400);
  }

  .login_footer_text1 {
    font-family: Pretendard;
    font-style: normal;
    font-size: 10px;
    font-weight: 500;
    color: var(--GrayScale-400);
    text-align: center;
    margin-top: auto;
  }
`;
